/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_Q3Inputs */

const en_pc_alt_faq_q3 = /** @type {(inputs: Pc_Alt_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PDFCraftTool/pdfcraft the same as PdfCraft?`)
};

const zh_pc_alt_faq_q3 = /** @type {(inputs: Pc_Alt_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFCraftTool/pdfcraft 和 PdfCraft 是同一个东西吗？`)
};

/**
* | output |
* | --- |
* | "Is PDFCraftTool/pdfcraft the same as PdfCraft?" |
*
* @param {Pc_Alt_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_q3 = /** @type {((inputs?: Pc_Alt_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_q3(inputs)
	return zh_pc_alt_faq_q3(inputs)
});
export { pc_alt_faq_q3 as "pc.alt.faq.q3" }